import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { api as rootCauseAPI } from '@saucelabs/sl-module-root-cause';

import * as types from './types';

export const cleanup = createAction(types.CLEANUP);

export const getRootCauses = createApiAction(
  types.GET_ROOT_CAUSES,
  ({ params, index }) => rootCauseAPI.getRootCauses(params)
    .then(({ data }) => ({ index, results: data.results }))
    .catch((error) => ({ index, error })),
  { meta: { skipErrorPage: true } },
);

export const getFailureTests = createApiAction(
  types.GET_FAILURE_TESTS,
  (params) => rootCauseAPI.getFailureTests(params),
  { meta: { skipErrorPage: true } },
);
